/* ===================================================================
   Tilkøb (upsell) - checkbox-stil
   - Checkbox tilkøb opdaterer stor pris live
   - Add-to-cart sender hoved + valgte tilkøb i ét kald
   - Cart drawer åbner korrekt via renderContents()
   =================================================================== */

(function () {
  'use strict';

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    const groups = document.querySelectorAll('[data-tilkoeb-group]');

    const productFormEl = document.querySelector('product-form');
    const productForm   = (productFormEl && productFormEl.querySelector('form[action*="/cart/add"]'))
                          || document.querySelector('form[action*="/cart/add"]');
    if (!productForm) return;

    const submitBtn = productForm.querySelector('[type="submit"], .product-form__submit');
    if (!submitBtn) return;

    const priceWrapper = document.querySelector('[id^="price-"].price-wrapper')
                         || document.querySelector('[id^="price-"]');

    /* --- Pris-helpers --- */
    function formatDKK(cents) {
      return (cents / 100).toLocaleString('da-DK', {
        minimumFractionDigits: 2, maximumFractionDigits: 2
      }) + ' kr';
    }

    function parsePrice(text) {
      if (!text) return 0;
      const clean = text.replace(/[^\d.,]/g, '');
      const norm  = clean.includes(',') ? clean.replace(/\./g, '').replace(',', '.') : clean;
      const v     = parseFloat(norm);
      return isNaN(v) ? 0 : Math.round(v * 100);
    }

    function getActivePriceItem() {
      if (!priceWrapper) return null;
      const isOnSale = priceWrapper.querySelector('.price')?.classList.contains('price--on-sale');
      if (isOnSale) return priceWrapper.querySelector('.price__sale .price-item--sale')
                         || priceWrapper.querySelector('.price-item--sale');
      return priceWrapper.querySelector('.price__regular .price-item--regular')
             || priceWrapper.querySelector('.price-item--regular')
             || priceWrapper.querySelector('.price-item');
    }

    let basePrice   = 0;
    let isOurUpdate = false;

    function readBasePrice() {
      const item = getActivePriceItem();
      return item ? parsePrice(item.textContent) : 0;
    }

    basePrice = readBasePrice();

    /* --- Tilkøb --- */
    function getSelectedAddons() {
      const addons = [];
      groups.forEach(group => {
        group.querySelectorAll('input[type="checkbox"]:checked').forEach(cb => {
          if (cb.value) addons.push({ id: parseInt(cb.value, 10), price: parseInt(cb.dataset.price, 10) || 0 });
        });
      });
      return addons;
    }

    function getAddonSum() {
      return getSelectedAddons().reduce((s, a) => s + a.price, 0);
    }

    function setDisplayedPrice(cents) {
      const item = getActivePriceItem();
      if (!item) return;
      const newText = formatDKK(cents);
      if (item.textContent === newText) return;
      isOurUpdate = true;
      item.textContent = newText;
      requestAnimationFrame(() => requestAnimationFrame(() => { isOurUpdate = false; }));
    }

    function applyAdjustment() {
      setDisplayedPrice(basePrice + getAddonSum());
    }

    if (groups.length > 0) {
      groups.forEach(g => g.addEventListener('change', applyAdjustment));
    }

    /* --- Variant-skift --- */
    if (priceWrapper) {
      new MutationObserver(() => {
        if (isOurUpdate) return;
        const newBase = readBasePrice();
        if (newBase > 0 && newBase !== basePrice + getAddonSum()) {
          basePrice = newBase;
          if (getAddonSum() > 0) applyAdjustment();
        }
      }).observe(priceWrapper, { childList: true, subtree: true, characterData: true });
    }

    if (window.subscribe && window.PUB_SUB_EVENTS?.variantChange) {
      window.subscribe(window.PUB_SUB_EVENTS.variantChange, (event) => {
        if (event?.data?.variant?.price != null) {
          basePrice = event.data.variant.price;
          if (getAddonSum() > 0) applyAdjustment();
        }
      });
    }

    /* --- Add-to-cart --- */
    async function doCartAdd() {
      const formData = new FormData(productForm);
      const mainId   = formData.get('id');
      if (!mainId) { showError('Vælg venligst en variant'); return; }

      const mainQty = parseInt(formData.get('quantity') || '1', 10);
      const addons  = getSelectedAddons();

      const properties = {};
      formData.forEach((value, key) => {
        const match = key.match(/^properties\[(.+)\]$/);
        if (match && value) properties[match[1]] = value;
      });

      const items = [{ id: parseInt(mainId, 10), quantity: mainQty }];
      if (Object.keys(properties).length > 0) items[0].properties = properties;
      addons.forEach(a => items.push({ id: a.id, quantity: 1 }));

      submitBtn.setAttribute('aria-disabled', 'true');
      submitBtn.classList.add('loading');

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({
            items,
            sections: ['cart-drawer', 'cart-icon-bubble'],
            sections_url: window.location.pathname
          })
        });

        const data = await res.json();
        if (!res.ok) { showError(data.description || data.message || 'Kunne ikke tilføje til kurv'); return; }

        const cartDrawerEl = document.querySelector('cart-drawer');
        if (cartDrawerEl && typeof cartDrawerEl.renderContents === 'function' && data.sections) {
          cartDrawerEl.renderContents(data);
        } else {
          window.location.href = '/cart';
        }

        try {
          if (window.PUB_SUB_EVENTS && window.publish) {
            window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'tilkoeb-upsell', productVariantId: mainId, cartData: data });
          }
        } catch(e) {}

      } catch (err) {
        console.error('[Tilkøb] Cart fejl:', err);
        showError('Der opstod en fejl. Prøv igen.');
      } finally {
        submitBtn.setAttribute('aria-disabled', 'false');
        submitBtn.classList.remove('loading');
      }
    }

    /* --- Intercept submit + floating-buy-button --- */
    submitBtn.addEventListener('click', async (e) => {
      e.preventDefault();
      e.stopImmediatePropagation();
      e.stopPropagation();
      if (!productForm.checkValidity()) { productForm.reportValidity(); return; }
      await doCartAdd();
    }, true);

    const floatingBuyBtn = document.getElementById('floating-buy-button');
    if (floatingBuyBtn) {
      floatingBuyBtn.addEventListener('click', async (e) => {
        e.preventDefault();
        e.stopImmediatePropagation();
        e.stopPropagation();
        if (!productForm.checkValidity()) { productForm.reportValidity(); return; }
        await doCartAdd();
      }, true);
    }

    function showError(msg) {
      const errorWrap = productFormEl?.querySelector('.product-form__error-message-wrapper');
      const errorMsg  = errorWrap?.querySelector('.product-form__error-message');
      if (errorWrap && errorMsg) {
        errorMsg.textContent = msg;
        errorWrap.removeAttribute('hidden');
        setTimeout(() => errorWrap.setAttribute('hidden', ''), 6000);
      } else { alert(msg); }
    }

    if (getAddonSum() > 0) applyAdjustment();
  }
})();
